var map = {
	"./EZ-Classroom-1.png": "8fa2",
	"./EZ-Classroom-2.png": "cd96",
	"./EZ-Self-1.png": "17c6",
	"./EZ-Self-2.png": "65c3",
	"./ezstudio-logo-only-logo.png": "75ea",
	"./ezstudio-logo.png": "3d54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17ac";